import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FirebaseApp } from 'angularfire2';
import { storage } from 'firebase';
import { HttpEventType, HttpResponse } from '@angular/common/http';

import { FileManagerModel } from '../../file-manager/models/file-manager.model';
import { FileManagerService } from '../../file-manager/services/file-manager.service';

import { ImageCropperComponent, CropperSettings } from 'ngx-img-cropper';

import Swal from 'sweetalert2';

@Component({
    selector: 'app-modal-upload-plugin',
    templateUrl: './modal-upload.component.html',
    styleUrls: ['./modal-upload.component.scss'],
    providers: [FileManagerModel, FileManagerService]
})

export class ModalUploadPluginComponent {

    typeImage = false;
    uploadMode = true;
    fileName: any;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropperReady = false;
    percentage = 0;
    storeRef: storage.Reference;
    archive: any;
    resizeToWidth: number;
    aspectRatio: string;
    horizontal: boolean;
    format: string;
    onlyType: string;
    maintainAspectRatio = true;
    private extension: string;


    @ViewChild('cropper') cropper: ImageCropperComponent;
    cropperSettings: CropperSettings;
    cropperData: any;

    public storage: ('firebase' | 'cloudinary') = 'cloudinary';

    constructor(
        private _fileManagerService: FileManagerService,
        public dialogRef: MatDialogRef<ModalUploadPluginComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        @Inject(FirebaseApp) fb: any
    ) {
        this.storeRef = fb.storage().ref();
        this.typeImage = (data.type === 'image') ? true : false;
        this.resizeToWidth = data.resizeToWidth;
        this.aspectRatio = data.aspectRatio;
        this.horizontal = data.horizontal;
        this.onlyType = data.onlyType;

        this.cropperSettings = new CropperSettings();
        this.cropperSettings.noFileInput = true;
        this.cropperSettings.keepAspect = false;
        this.cropperSettings.preserveSize = true;
        this.cropperSettings.dynamicSizing = true;
        this.cropperData = {};
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    reset() {
        this.croppedImage = '';
        this.fileName = '';
        this.imageChangedEvent = '';
        this.cropperReady = false;
    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }

    imageCroppedBase64(image: string) {
        this.croppedImage = image;
    }

    imageLoaded() {
        this.cropperReady = true;
    }

    imageLoadFailed() {
        console.log('Load failed');
    }

    UploadImage(event) {
        if (event.srcElement.files[0]) {
            this.imageChangedEvent = event;
            this.format = 'image/webp';
            this.extension = 'webp';

            this.fileName = `${this.uid()}.webp`;

            const myReader: FileReader = new FileReader();
            myReader.onloadend = (loadEvent: any) => {
                const image = new Image();
                image.src = loadEvent.target.result;
                this.cropper.setImage(image);
                this.cropperReady = true;
                this.croppedImage = true;

            };
            myReader.readAsDataURL(event.srcElement.files[0]);
        }
    }

    getWebPBlob(dataURI: string, quality: number = 0.85): Promise<Blob> {
        return new Promise((resolve) => {
            try {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.naturalWidth || img.width;
                    canvas.height = img.naturalHeight || img.height;
                    const ctx = canvas.getContext('2d');
                    if (ctx) {
                        ctx.drawImage(img, 0, 0);
                        if (canvas.toBlob) {
                            canvas.toBlob((blob) => {
                                resolve(blob || this.dataURItoBlob(dataURI));
                            }, 'image/webp', quality);
                            return;
                        }
                    }
                    resolve(this.dataURItoBlob(dataURI));
                };
                img.onerror = () => resolve(this.dataURItoBlob(dataURI));
                img.src = dataURI;
            } catch (e) {
                resolve(this.dataURItoBlob(dataURI));
            }
        });
    }

    dataURItoBlob(dataURI) {
        const type = 'image/png';
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        const bb = new Blob([ab], { type: type });
        return bb;
    }

    sendImage() {
        this.getWebPBlob(this.cropperData.image).then((imagee: Blob) => {
            this.format = 'image/webp';
            this.extension = 'webp';
            this.fileName = `${this.uid()}.webp`;

            if (this.storage === 'firebase') {
                const caminho = this.storeRef.child('images/' + Math.random().toString(36).replace(/[^a-z]+/g, '')
                  .substr(0, 10) + this.fileName);
                const metadata = { contentType: 'image/webp' };
                const tarefa = caminho.put(imagee, metadata);
                tarefa.on('state_changed',
                    (snapshot) => {
                        this.percentage = Math.round((tarefa.snapshot.bytesTransferred / tarefa.snapshot.totalBytes) * 100);
                    },
                    (error) => {

                    },
                    () => {
                        if (tarefa.snapshot.state === 'success') {
                            caminho.getDownloadURL().then(url => {
                                this.dialogRef.close({
                                    path: url,
                                    name: this.fileName,
                                    size: tarefa.snapshot.totalBytes,
                                    format: this.format
                                });
                            });
                        }
                    }
                );
            } else {
                const formData: FormData = new FormData();
                formData.append('file', imagee, this.fileName);
                this._fileManagerService.uploadToCloudinary(formData).subscribe((response: any) => {

                    if (response.loaded && response.total) {
                        this.percentage = Math.trunc(100 * response.loaded / response.total);
                    } else if (response.body) {
                        this.dialogRef.close({
                            path: response.body.file.url,
                            name: this.fileName,
                            size: response.body.file.bytes,
                            format: this.format,
                            aspect: response.body.file.width / response.body.file.height
                        });
                    }
                });
            }
        });
    }

    UploadArchive(event) {
        const file = (event && event.srcElement && event.srcElement.files && event.srcElement.files[0]) ||
                     (event && event.target && event.target.files && event.target.files[0]);
        if (file && this.whiteListUploads(file.type)) {
            const isImage = (file.type && file.type.startsWith('image/')) || /\.(jpe?g|png|gif|bmp|webp)$/i.test(file.name);
            if (isImage) {
                this.format = 'image/webp';
                this.extension = 'webp';
                const baseName = file.name.substring(0, file.name.lastIndexOf('.')) || this.uid();
                this.fileName = `${baseName}.webp`;

                const reader = new FileReader();
                reader.onloadend = async (loadEvent: any) => {
                    const webpBlob = await this.getWebPBlob(loadEvent.target.result);
                    this.archive = webpBlob;
                };
                reader.readAsDataURL(file);
            } else {
                this.fileName = file.name;
                this.archive = file;
                this.format = file.type;
                this.extension = this.getFileExtension(file.name);
            }
        } else {
            Swal.fire({
                type: 'error',
                title: 'Erro ao carregar o arquivo.',
                text: 'Verifique se o arquivo tem o formato permitido.',
                buttonsStyling: true,
                confirmButtonClass: 'btn btn-success'
            });
        }
    }

    sendArchive() {
        /** Para envio de arquivos o Cloudinary deu erro **/
        if (true || this.storage === 'firebase') {
            if (this.format === 'application/pdf') {
                // this.sendToServer();
                this.sendToFirebase();
            } else {
                this.sendToFirebase();
            }
        }
        // else {
        //     const formData: FormData = new FormData();
        //     formData.append('file', this.archive);
        //     this._fileManagerService.uploadToCloudinary(formData).subscribe((response: any) => {
        //         console.log("[uploadToCloudinary] response", response);
        //         if (response.loaded && response.total) {
        //             this.percentage = Math.trunc(100 * response.loaded / response.total);
        //         }
        //         else if (response.body) {
        //             this.dialogRef.close({
        //                 path: response.body.file.url,
        //                 name: this.fileName,
        //                 size: response.body.file.bytes,
        //                 format: this.format,
        //                 aspect: response.body.file.width / response.body.file.height
        //             });
        //         }
        //     });
        // }
    }

    sendToServer() {
        this._fileManagerService.uploadFile(this.archive)
            .subscribe(res => {
                console.log(res);
                if (res.type === HttpEventType.UploadProgress) {
                    this.percentage = Math.round(100 * res.loaded / res.total);
                } else if (res instanceof HttpResponse) {
                    this.dialogRef.close({
                        path: res.body.data.url,
                        name: res.body.data.name,
                        format: 'application/pdf'
                    });
                }
            });
    }

    sendToFirebase() {
        this.extension = this.getFileExtension(this.fileName);
        let storePath  = this.storeRef.child(`images`).child(`${this.uid().split('-')[0]
            + '_' + this.fileName.split('.')[0] }.${this.extension}`);

        if (this.format === 'application/pdf') {
          storePath = this.storeRef.child('archives').child(this.uid().split('-')[0]
            + '_' + this.fileName.split('.')[0] + '.' + this.extension );
        }

        const metadata = (this.format === 'image/webp' || this.extension === 'webp')
            ? { contentType: 'image/webp' }
            : (this.format ? { contentType: this.format } : undefined);

        const tarefa = metadata ? storePath.put(this.archive, metadata) : storePath.put(this.archive);

        tarefa.on('state_changed', (snapshot) => {
            this.percentage = Math.round((tarefa.snapshot.bytesTransferred / tarefa.snapshot.totalBytes) * 100);
        }, error => {
        }, () => {
            if (tarefa.snapshot.state === 'success') {
              storePath.getDownloadURL().then(url => {
                    this.dialogRef.close({
                        path: url,
                        name: this.fileName,
                        format: this.format
                    });
                });
            }
        });
    }

    private whiteListUploads(fileType: any): boolean {
        switch (fileType) {
            case 'image/png':
                return true;
            case 'image/jpeg':
                return true;
            case 'image/jpg':
                return true;
            case 'image/gif':
                return true;
            case 'image/webp':
                return true;
            case 'image/bmp':
                return true;
            case 'application/msword':
                return true;
            case 'application/pdf':
                return true;
            case 'application/zip':
                return true;
            case 'application/vnd.ms-excel':
                return true;
            case 'video/x-flv':
                return true;
            case 'video/mp4':
                return true;
            case 'application/x-mpegURL':
                return true;
            case 'video/MP2T':
                return true;
            case 'video/3gpp':
                return true;
            case 'video/quicktime':
                return true;
            case 'video/x-msvideo':
                return true;
            case 'video/x-ms-wmv':
                return true;
            case '':
                return true;
            default:
                return true;
        }
    }

    uid() {
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
            this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }

    s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    getFileExtension(filename: string) {
        return filename.split('.').pop();
    }


    cropperSettingsChanged(field, value) {
        // this.cropper
        this.cropperSettings[field] = value;
        this.cropperSettings = JSON.parse(JSON.stringify(this.cropperSettings));
    }
}




// WEBPACK FOOTER //
// ./src/app/modules/shared/upload/modal-upload/modal-upload.component.ts